import { useRef, useState, useEffect } from 'react'
import logo from '../assets/img/logo.png'
import logoNoBg from '../assets/img/logo-no-bg.svg'
import { RxHamburgerMenu } from 'react-icons/rx'
import { IoMdClose } from 'react-icons/io'
import { useInView } from 'react-intersection-observer'
import { useSiteSettings } from '../contexts/SiteSettingsContext'

export function Header() {
    const nav = useRef()
    const [isNavVisible, setIsNavVisible] = useState("false")
    const { ref: scrollTracker, inView: isVisible } = useInView()

    // Read phone from shared context — no extra API call
    const settings = useSiteSettings()
    const phone = settings?.phone || '+972508993111'

    useEffect(() => {
        if (isNavVisible === "true") {
            document.body.classList.add('menu-open')
        } else {
            document.body.classList.remove('menu-open')
        }
        return () => {
            document.body.classList.remove('menu-open')
        }
    }, [isNavVisible])

    useEffect(() => {
        let resizeTimer
        const handleResize = () => {
            if (nav.current) {
                nav.current.classList.add('no-transition')
            }
            if (window.innerWidth >= 768) {
                setIsNavVisible("false")
            }
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(() => {
                if (nav.current) {
                    nav.current.classList.remove('no-transition')
                }
            }, 100)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
            clearTimeout(resizeTimer)
        }
    }, [])

    const onMenuClick = () => {
        setIsNavVisible(prev => prev === "true" ? "false" : "true")
    }

    return <header className={`header main-layout full ${!isVisible ? 'scroll' : ''}`}>
        <div className='flex align-center'>
            <button className='hamburger-btn'
                onClick={onMenuClick}
                aria-label='menu'
            >
                {isNavVisible === "false" ? <RxHamburgerMenu /> : <IoMdClose />}
            </button>
            <div
                className={`menu-backdrop ${isNavVisible === 'true' ? 'visible' : ''}`}
                onClick={onMenuClick}
            ></div>
            <nav className='flex column align-center' data-visible={isNavVisible} ref={nav}>
                <div className="button-container">
                    <a href={`tel:${phone}`} className="call-btn">התקשרו אלינו</a>
                </div>
                <ul className='flex column justify-between align-center'>
                    <li onClick={onMenuClick}><a href="#hero">בית</a></li>
                    <li onClick={onMenuClick}><a href="#experience">קצת עלינו</a></li>
                    <li onClick={onMenuClick}><a href="#gallery">גלריה</a></li>
                    <li onClick={onMenuClick}><a href="#reviews">המלצות</a></li>
                    <li onClick={onMenuClick}><a href="#contact">צור קשר</a></li>
                </ul>
            </nav>
            <img className='logo' src={logo} alt="logo" />
            {/* scroll-tracker is used by useInView to detect when header is out of viewport */}
            <div className="scroll-tracker" ref={scrollTracker} />
        </div>
        <div className='scrolling-header'>
            <a href="#hero"><img className='logo-secondary' src={logoNoBg} alt="" /></a>
        </div>
    </header>
}